<template>
  <div>
    <service-cn v-if="lan=='cn'"></service-cn>
    <service-en v-if="lan=='en'"></service-en>
  </div>
</template>

<script>
import serviceCn from './userprotocol'
import serviceEn from './en/service_agreement'
export default {
  data(){
    return {
      lan: ""
    }
  },
  components: {
    serviceCn,serviceEn
  },
  mounted(){
    this.lan = this.$route.query.lan
  }
}
</script>


// WEBPACK FOOTER //
// src/components/service.vue